module.exports = __webpack_public_path__ + "img/mail.b5b6f1a5.svg";